import { Grid, makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import Order from "../../actions/order";
import {
  Autocomplete,
  Box,
  CircularProgress,
  FormHelperText,
  MenuItem,
  Typography,
} from "@mui/material";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import produce from "immer";
import TextField from "@material-ui/core/TextField";
import CheckIcon from "@mui/icons-material/Check";
import Customer from "../../actions/customer";

const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));

const ChangeCustomer = ({ NotifyMessage, setOpenPopup, id,getOrderData }) => {
  const classes = useStyles();
  const { updateOrderCustomer } = Order();
  const { viewAllCustomers } = Customer();
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [customers, setCustomers] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  useEffect(() => {
    getAllCustomers();
  }, []);

  const getAllCustomers = () => {
    setValues({ ...values, loading: true });
    viewAllCustomers().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.customers) {
        setValues({
          ...values,
          loading: false,
        });
        setCustomers(data.customers);
      }
    });
  };
  const handleSubmit = () => {
    setValues({ ...values, submitting: true });

    updateOrderCustomer({ cusomerId: selectedCustomer.id }, id).then((data) => {
      if (data.err) {
        setValues({ ...values, submitting: false });
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: "Customer successfully changed",
          type: "success",
        });
        setOpenPopup(false);
        getOrderData();
      }
    });
  };

  const handleAddClick = (e) => {
    e.preventDefault();

    if (!selectedCustomer) {
      setCustomerError(true);
    } else {
      setCustomerError(false);
      handleSubmit();
    }
  };
  const handleCustomerSelect = (customer) => {
    setSelectedCustomer(customer);
  };
  const [customerError, setCustomerError] = useState(false);

  return (
    <Form onSubmit={handleAddClick}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Autocomplete
            options={customers}
            disableClearable
            getOptionLabel={(option) => `${option.fullName}`}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Customer"
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                }}
              />
            )}
            onChange={(event, value) => handleCustomerSelect(value)}
          />
          {customerError && (
            <FormHelperText error>
              Please select a customer
            </FormHelperText>
          )}
        </Grid>
        {selectedCustomer && (
          <Grid item xs={12} md={6}>
            <Box mt={2}>
              <Typography variant="body1">
                <strong>Phone Number:</strong> {selectedCustomer.phoneNo}
              </Typography>
              <Typography variant="body1">
                <strong>Email:</strong> {selectedCustomer.email}
              </Typography>
    
            </Box>
          </Grid>
        )}
        {!selectedCustomer && <Grid item xs={12} md={6} />}
        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={values.submitting ? "Changing..." : "Done"}
              variant="contained"
              className="Button"
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              variant="contained"
              className="Button"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default ChangeCustomer;
